import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import extPromo from '@/assets/images/ext_promo.png';
import { NotificationId } from '@/modules/api/codegen';
import { Modal } from '@/modules/modals';
import { useNotification } from '@/modules/notifications/hooks';
import { Heading, Text } from '@/modules/ui';

import { buttons, container, heading, promo, wrapper } from './ExtensionInstallationDialog.rules';

export interface ExtensionInstallationDialogProps {
    extensionStoreUrl: string;
}

export const ExtensionInstallationDialog = ({ extensionStoreUrl }: ExtensionInstallationDialogProps) => {
    const { css } = useFela();
    const { notification, isLoading, update } = useNotification(NotificationId.extensionInstallation);
    const visible = !isLoading && !notification?.dismissedAt && update.status !== 'error';

    return (
        <Modal
            open={visible}
            okButton={{
                disabled: update.isPending,
                async onClick() {
                    window.open(new URL(extensionStoreUrl), '_blank', 'noopener,noreferrer');
                    await update.resolveNotification();
                },
                children: <FormattedMessage id='extension.modal.ok' />,
            }}
            cancelButton={{
                onClick: update.rejectNotification,
                disabled: update.isPending,
                children: <FormattedMessage id='extension.modal.cancel' />,
                'data-testid': 'extension-modal-cancel-button',
            }}
            width={400}
            extend={{
                container,
                buttons,
            }}
        >
            <img src={extPromo} alt='' className={css(promo)} />
            <div className={css(wrapper)}>
                <Heading elementType='h2' color='black' customStyle={heading}>
                    <FormattedMessage id='extension.modal.title' />
                </Heading>
                <Text color='brownGrey2'>
                    <FormattedMessage id='extension.modal.text' />
                </Text>
            </div>
        </Modal>
    );
};
